export default function CarouselSection() {
  return (
    <section id="carousel" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 text-center mb-8">
          深度深扒
        </h2>

        <div className="space-y-5">
          <div className="flex flex-col md:flex-row gap-5 bg-background-100 rounded-lg overflow-hidden border border-background-200/70 cursor-pointer hover:border-primary-200 transition-colors group">
            <div className="w-full md:w-72 h-48 md:h-auto flex-shrink-0">
              <img
                src="https://readdy.ai/api/search-image?query=Dramatic%20behind%20the%20scenes%20entertainment%20industry%20scene%2C%20dark%20backstage%20of%20variety%20show%2C%20mysterious%20atmosphere%2C%20warm%20crimson%20and%20amber%20tones%2C%20cinematic%20lighting%2C%20editorial%20documentary%20style%2C%20no%20visible%20faces%2C%20investigative%20mood%2C%20dramatic%20shadows&width=600&height=400&seq=carousel-baoliao-01&orientation=landscape"
                alt="综艺节目幕后黑幕大起底，某导演被曝收受选手贿赂操控比赛排名"
                title="综艺节目幕后黑幕大起底，某导演被曝收受选手贿赂操控比赛排名"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-5 flex flex-col justify-center">
              <span className="text-xs text-primary-500 font-medium mb-2">深度调查</span>
              <h3 className="text-base md:text-lg font-heading font-bold text-foreground-950 mb-2">
                综艺节目幕后黑幕大起底，某导演被曝收受选手贿赂操控比赛排名
              </h3>
              <p className="text-sm text-foreground-600 line-clamp-2">
                近日，多位知情人士向51爆料网透露，某热门选秀综艺节目导演长期收受选手经纪公司贿赂，通过操控评委打分、剪辑偏向等方式影响比赛结果。据不完全统计，本赛季已有多名选手的排名与实际表现严重不符。
              </p>
              <div className="mt-3 flex items-center gap-3 text-xs text-foreground-500">
                <span><i className="ri-time-line mr-1"></i>2小时前</span>
                <span><i className="ri-eye-line mr-1"></i>12.8万阅读</span>
              </div>
            </div>
          </div>

          <div className="flex flex-col md:flex-row gap-5 bg-background-100 rounded-lg overflow-hidden border border-background-200/70 cursor-pointer hover:border-primary-200 transition-colors group">
            <div className="w-full md:w-72 h-48 md:h-auto flex-shrink-0">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20luxury%20brand%20store%20interior%20with%20dramatic%20contrast%20lighting%2C%20empty%20display%20shelves%2C%20dark%20moody%20atmosphere%2C%20amber%20spotlights%2C%20investigative%20documentary%20style%2C%20shadow%20play%20on%20walls%2C%20editorial%20photography%2C%20no%20people%2C%20conceptual%20luxury%20scene&width=600&height=400&seq=carousel-baoliao-02&orientation=landscape"
                alt="某奢侈品牌大中华区高管被曝财务造假，涉及金额超千万"
                title="某奢侈品牌大中华区高管被曝财务造假，涉及金额超千万"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-5 flex flex-col justify-center">
              <span className="text-xs text-primary-500 font-medium mb-2">财务黑幕</span>
              <h3 className="text-base md:text-lg font-heading font-bold text-foreground-950 mb-2">
                某奢侈品牌大中华区高管被曝财务造假，涉及金额超千万
              </h3>
              <p className="text-sm text-foreground-600 line-clamp-2">
                内部审计文件显示，该品牌大中华区某高管在过去三年间通过虚报营销费用、伪造供应商合同等手段，累计套取公司资金逾千万元。目前品牌总部已启动独立调查程序，涉事高管已被停职处理。
              </p>
              <div className="mt-3 flex items-center gap-3 text-xs text-foreground-500">
                <span><i className="ri-time-line mr-1"></i>5小时前</span>
                <span><i className="ri-eye-line mr-1"></i>9.6万阅读</span>
              </div>
            </div>
          </div>

          <div className="flex flex-col md:flex-row gap-5 bg-background-100 rounded-lg overflow-hidden border border-background-200/70 cursor-pointer hover:border-primary-200 transition-colors group">
            <div className="w-full md:w-72 h-48 md:h-auto flex-shrink-0">
              <img
                src="https://readdy.ai/api/search-image?query=Dark%20courthouse%20corridor%20with%20dramatic%20shadows%2C%20legal%20documents%20scattered%20on%20table%2C%20warm%20amber%20light%20through%20windows%2C%20cinematic%20noir%20style%2C%20investigative%20journalism%20mood%2C%20editorial%20photography%2C%20no%20people%2C%20atmospheric%20tension&width=600&height=400&seq=carousel-baoliao-03&orientation=landscape"
                alt="某知名企业家涉嫌合同诈骗被立案调查，公司股价暴跌"
                title="某知名企业家涉嫌合同诈骗被立案调查，公司股价暴跌"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-5 flex flex-col justify-center">
              <span className="text-xs text-primary-500 font-medium mb-2">商业丑闻</span>
              <h3 className="text-base md:text-lg font-heading font-bold text-foreground-950 mb-2">
                某知名企业家涉嫌合同诈骗被立案调查，公司股价暴跌
              </h3>
              <p className="text-sm text-foreground-600 line-clamp-2">
                据权威消息源证实，某上市公司创始人在一笔跨境并购交易中涉嫌伪造审计报告和虚增估值，导致收购方损失惨重。警方已于近日对其立案侦查，受此影响该公司股价在三个交易日内累计下跌超过40%。
              </p>
              <div className="mt-3 flex items-center gap-3 text-xs text-foreground-500">
                <span><i className="ri-time-line mr-1"></i>8小时前</span>
                <span><i className="ri-eye-line mr-1"></i>15.3万阅读</span>
              </div>
            </div>
          </div>

          <div className="flex flex-col md:flex-row gap-5 bg-background-100 rounded-lg overflow-hidden border border-background-200/70 cursor-pointer hover:border-primary-200 transition-colors group">
            <div className="w-full md:w-72 h-48 md:h-auto flex-shrink-0">
              <img
                src="https://readdy.ai/api/search-image?query=Dark%20film%20set%20with%20dramatic%20spotlight%2C%20empty%20director%20chair%2C%20scattered%20script%20pages%2C%20warm%20crimson%20and%20deep%20shadow%20tones%2C%20cinematic%20behind%20the%20scenes%2C%20investigative%20mood%2C%20editorial%20photography%2C%20no%20people%2C%20dramatic%20atmosphere&width=600&height=400&seq=carousel-baoliao-04&orientation=landscape"
                alt="网曝某影视公司阴阳合同逃税，涉及多位一线明星"
                title="网曝某影视公司阴阳合同逃税，涉及多位一线明星"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-5 flex flex-col justify-center">
              <span className="text-xs text-primary-500 font-medium mb-2">税务黑料</span>
              <h3 className="text-base md:text-lg font-heading font-bold text-foreground-950 mb-2">
                网曝某影视公司阴阳合同逃税，涉及多位一线明星
              </h3>
              <p className="text-sm text-foreground-600 line-clamp-2">
                一份疑似内部财务表格近日在业内流传，表格详细列出了一家头部影视制作公司与多位一线明星签订阴阳合同的详情。爆料人声称，通过这种操作，相关明星在过去五年间累计逃避个人所得税超亿元。
              </p>
              <div className="mt-3 flex items-center gap-3 text-xs text-foreground-500">
                <span><i className="ri-time-line mr-1"></i>12小时前</span>
                <span><i className="ri-eye-line mr-1"></i>22.1万阅读</span>
              </div>
            </div>
          </div>

          <div className="flex flex-col md:flex-row gap-5 bg-background-100 rounded-lg overflow-hidden border border-background-200/70 cursor-pointer hover:border-primary-200 transition-colors group">
            <div className="w-full md:w-72 h-48 md:h-auto flex-shrink-0">
              <img
                src="https://readdy.ai/api/search-image?query=Dark%20gym%20interior%20with%20dramatic%20lighting%2C%20empty%20training%20equipment%2C%20shadows%20on%20floor%2C%20warm%20amber%20and%20crimson%20mood%2C%20investigative%20documentary%20style%2C%20atmospheric%20tension%2C%20editorial%20photography%2C%20no%20people%2C%20conceptual%20sports%20scene&width=600&height=400&seq=carousel-baoliao-05&orientation=landscape"
                alt="某体育明星涉嫌服用禁药，国际组织已启动调查程序"
                title="某体育明星涉嫌服用禁药，国际组织已启动调查程序"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-5 flex flex-col justify-center">
              <span className="text-xs text-primary-500 font-medium mb-2">体育圈内幕</span>
              <h3 className="text-base md:text-lg font-heading font-bold text-foreground-950 mb-2">
                某体育明星涉嫌服用禁药，国际组织已启动调查程序
              </h3>
              <p className="text-sm text-foreground-600 line-clamp-2">
                一份未公开的兴奋剂检测报告显示，某知名运动员在最近一次赛外飞行检查中A瓶样本呈阳性。尽管B瓶检测结果尚未公布，但国际相关组织已正式启动调查程序。如果指控成立，该运动员将面临至少四年的禁赛处罚。
              </p>
              <div className="mt-3 flex items-center gap-3 text-xs text-foreground-500">
                <span><i className="ri-time-line mr-1"></i>1天前</span>
                <span><i className="ri-eye-line mr-1"></i>18.7万阅读</span>
              </div>
            </div>
          </div>

          <div className="flex flex-col md:flex-row gap-5 bg-background-100 rounded-lg overflow-hidden border border-background-200/70 cursor-pointer hover:border-primary-200 transition-colors group">
            <div className="w-full md:w-72 h-48 md:h-auto flex-shrink-0">
              <img
                src="https://readdy.ai/api/search-image?query=Dark%20luxury%20car%20dealership%20interior%20at%20night%2C%20dramatic%20shadow%20play%2C%20spotlights%20on%20floor%2C%20warm%20amber%20tones%2C%20cinematic%20noir%20atmosphere%2C%20investigative%20mood%2C%20editorial%20photography%2C%20no%20people%2C%20conceptual%20wealth%20scene&width=600&height=400&seq=carousel-baoliao-06&orientation=landscape"
                alt="某地官商勾结内幕曝光，涉案地产项目被紧急叫停"
                title="某地官商勾结内幕曝光，涉案地产项目被紧急叫停"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-5 flex flex-col justify-center">
              <span className="text-xs text-primary-500 font-medium mb-2">官场黑幕</span>
              <h3 className="text-base md:text-lg font-heading font-bold text-foreground-950 mb-2">
                某地官商勾结内幕曝光，涉案地产项目被紧急叫停
              </h3>
              <p className="text-sm text-foreground-600 line-clamp-2">
                据内部人士爆料，某地一处大型商业地产项目在土地审批环节存在严重违规操作，多名公职人员涉嫌受贿并违规为开发商开绿灯。此事曝光后，上级主管部门已责令项目立即停工，相关责任人已被纪检部门带走调查。
              </p>
              <div className="mt-3 flex items-center gap-3 text-xs text-foreground-500">
                <span><i className="ri-time-line mr-1"></i>1天前</span>
                <span><i className="ri-eye-line mr-1"></i>31.5万阅读</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}